import React from 'react';
import { Table } from 'semantic-ui-react';

import { SessionTypes } from 'PointOfSale/modules/common/constants';

const COLUMNS = {
  [SessionTypes.Queue]: ['Name', 'Serving number', 'ID'],
  [SessionTypes.Teacher]: ['Name'],
};

const LookUpResultHeaderTable = ({ activeSession }) => {
  const sessionTypeColumns = COLUMNS[activeSession];
  if (!sessionTypeColumns) return null;
  return (
    <Table basic="very">
      <Table.Header>
        <Table.Row>
          {sessionTypeColumns.map((column, index) => {
            return (
              <Table.HeaderCell
                key={`${column}_${index}`}
                width={index === 0 ? 8 : 4}
              >
                {column}
              </Table.HeaderCell>
            );
          })}
        </Table.Row>
      </Table.Header>
    </Table>
  );
};

export default LookUpResultHeaderTable;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/lookup/component/LookUpResultHeaderTable.js